<div class="mb-8">

    <div class="w-full flex justify-between mt-8 mb-4">
        <app-btn-back routeTo=".." fragment="assignments" icon="fa fa-close" btnText="Cancel"></app-btn-back>
    </div>

    <div class="mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            New Assignment
        </h1>
    </div>

    <div class="w-full mb-6">
        <form [formGroup]="pageForm" (ngSubmit)="create()">

            <div class="flex flex-wrap py-4">

                <div class="flex flex-row flex-nowrap w-full gap-2 mb-4">
                    <div class="flex flex-col w-full">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            End Date *
                        </label>
                        <input type="datetime-local" name="endDate" id="endDate" formControlName="endDate"
                            placeholder="dd/mm/yyyy"
                            class="rounded w-full border-0 outline-none ring-0 text-sm focus:outline-none focus:ring-0 shadow">
                    </div>
                </div>

                <div class="w-full flex flex-col gap-1 mb-4">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Lesson
                    </label>
                    <select (change)="onChangeLesson($event)"
                        class="appearance-none placeholder-blueGray-300 bg-white rounded text-sm shadow border-0 focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                        @for (item of lessons; track item.id) {
                        <option [selected]="pageForm.get('lessonId')?.value == item.id" [value]="item.id"
                            class="bg-white text-primary-500 text-sm">
                            {{item?.lessonName}}</option>
                        }
                    </select>
                </div>

                <div class="w-full flex flex-col gap-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Attachment Type
                    </label>
                    <select (change)="onChangeType($event)"
                        class="appearance-none placeholder-blueGray-300 bg-white rounded text-sm shadow border-0 focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                        @for (item of assignmentTypes; track item) {
                        <option [selected]="pageForm.get('type')?.value == item" [value]="item"
                            class="bg-white text-primary-500 text-sm">
                            {{item}}</option>
                        }
                    </select>
                </div>

                @if (pageForm.get('type')?.value == assignmentType.pdf) {
                <div class="w-full flex flex-col mt-4">
                    <app-s3-document-upload #uploader label="Upload Pdf" [preSignedUrlEndpoint]="preSignedUrlEndpoint"
                        [apikey]="apiKey" [formats]="['.pdf']"
                        [cloudFrontDomain]="cloudFrontDomain"></app-s3-document-upload>
                </div>
                }

                @if (pageForm.get('type')?.value == assignmentType.text) {
                <div class="w-full mt-1 mb-4">
                    <p class="text-primary-300 text-sm">Text editor will be available post assignment creation</p>
                </div>
                }

                <div class="w-full">
                    <app-btn-submit
                        [isDisabled]="!pageForm.valid || ((loading$ | async) ?? false) || (pageForm.get('type')?.value == assignmentType.pdf && !uploader?.getIsAttached())"
                        [isLoading]="(loading$ | async) ?? false" actionText="Create"></app-btn-submit>
                </div>
            </div>
        </form>
    </div>
</div>